export default __webpack_public_path__ + "static/10-d6e529eb4ebe617749ef0df3777007f7.png";